const view = /*html*/`

    
    <!--begin::Container-->
    <div id="kt_content_container" class="container-fluid">
        <style>
            .top-rank:nth-of-type(1)::after, .top-rank:nth-of-type(2)::after, .top-rank:nth-of-type(3)::after {
                content: "";
                position: absolute;
                left: 0px;
                top: 0px;
                height: 100%;
                width: 100%;
                z-index: 0;                 
                border: 0;
                box-sizing: border-box;
                color: #fff;
                margin: 0;
                padding: 0;
            }
            .top-rank:nth-of-type(1)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 60.91%, rgba(52, 49, 43, 0.4) 77.74%, rgba(255, 193, 7, 0.4) 102.88%);
            }
            .top-rank:nth-of-type(2)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 58.44%, rgba(39, 50, 70, 0.4) 78.79%, rgba(71, 94, 138, 0.4) 100%);
            }
            .top-rank:nth-of-type(3)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.3) 61.73%, rgba(51, 43, 44, 0.3) 80.47%, rgba(119, 78, 55, 0.3) 100%);
            }

            .top-trophy-1{
                color: #ffc107;
            }
            .top-trophy-2{
                color: #C0C0C0;
            }
            .top-trophy-3{
                color: #CD7F32;
            }
            .table-custom
            {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
            }
            
        </style>
        <div id="kt_content_container" class="container-xxl">

            <div class="d-flex flex-row flex-wrap align-items-center gap-2 justify-content-between mb-4 w-100">
                <div class="d-flex flex-row flex-wrap align-items-center gap-2">
                </div>
                <div class="d-flex flex-row flex-wrap align-items-center justify-content-end gap-2">
                    
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-xl-9">
                    <div class="card bg-transparent shadow-none">
                        <div class="card-header border-0 bg-gray-100 min-h-auto rounded">
                            <h3 class="card-title m-0">
                                <i class="far fa-user fs-5 me-2"></i><span class="text-dark fs-3 teko-header pt-1">Solo Ranked</span>
                            </h3>
                            <div class="card-toolbar">
                                <button class="btn btn-sm btn-flex btn-color-gray-muted border-hover-success btn-active-light-success btn-active-color-success border-0 solo-btn-settings">
                                    <i class="fad fa-cog fs-4 me-1"></i><span class="" data-i18n="solo.settings_dlg_title">Settings</span>
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row solo-members">
                                
                                
                            </div>
                        </div>
                    </div>
                    <div class="d-flex solo-bottom-buttons align-items-center justify-content-center solo-btn-matching mb-8">
                        
                    </div>
                </div>
                <div class="col-12 col-xl-3">
                    <div class="card shadow-none">
                        <div class="card-header border-0 bg-gray-100 min-h-auto rounded">
                            <h3 class="card-title m-0">
                                <i class="far fa-server fs-5 me-2"></i><span class="text-dark fs-3 teko-header pt-1">Servers</span>
                            </h3>
                            <div class="card-toolbar">
                                
                                <span class="btn btn-sm btn-flex btn-color-gray-muted border-0 fs-8">
                                    <span><span class="solo-servers-num-selected">0</span> <span>selected</span></span>
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="solo-servers">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

    </div>
    <!--end::Container-->

`;


export default view;